module.exports = __webpack_public_path__ + "static/img/saoma.38dce5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/saoma.png
// module id = MSkv
// module chunks = 6